import createSvgIcon from '../Utils/CreateSvgIcon';

export const DoneOutline = createSvgIcon(
  <path d="m381-266.5 397.23-397.23-26.08-25.96-370.88 371.15-173.81-173.54L181.38-466 381-266.5Zm0 52.54L128.96-466l78.5-78.62L381-371.08 753.19-743l78.46 78.77L381-213.96Z" />,
  'DoneOutline',
  '0 -960 960 960',
);
